/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Find_Replace_Search_Results_ToastInputs */

const en_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Search returned ${i?.count} results`)
};

const fr_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La recherche a retourne ${i?.count} resultats`)
};

const de_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Suche ergab ${i?.count} Ergebnisse`)
};

const it_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La ricerca ha restituito ${i?.count} risultati`)
};

const ru_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Поиск выдал ${i?.count} результатов`)
};

const es_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La búsqueda arrojó ${i?.count} resultados`)
};

const zh_cn2_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`搜索结果为${i?.count}`)
};

const ja_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`検索により ${i?.count} 件の結果が返されました`)
};

const hi_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`खोज में ${i?.count} परिणाम प्राप्त हुए`)
};

const pt_pt2_find_replace_search_results_toast = /** @type {(inputs: Find_Replace_Search_Results_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A pesquisa retornou ${i?.count} resultados`)
};

/**
* | output |
* | --- |
* | "Search returned {count} results" |
*
* @param {Find_Replace_Search_Results_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_search_results_toast = /** @type {((inputs: Find_Replace_Search_Results_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_Search_Results_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_search_results_toast(inputs)
	if (locale === "de") return de_find_replace_search_results_toast(inputs)
	if (locale === "it") return it_find_replace_search_results_toast(inputs)
	if (locale === "ru") return ru_find_replace_search_results_toast(inputs)
	if (locale === "es") return es_find_replace_search_results_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_search_results_toast(inputs)
	if (locale === "ja") return ja_find_replace_search_results_toast(inputs)
	if (locale === "hi") return hi_find_replace_search_results_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_search_results_toast(inputs)
	return en_find_replace_search_results_toast(inputs)
});